import { useState } from 'react';

const hex = (text: string) => [...text].map((char) => char.codePointAt(0)!.toString(16));

/**
 * Nombre del archivo de Twemoji: los puntos de código en hexadecimal. El
 * selector de variante (FE0F) solo se conserva en las secuencias con ZWJ.
 */
export function emojiFile(emoji: string, stripAll = false): string {
  const codes = hex(emoji);
  const keep = !stripAll && codes.includes('200d');
  return (keep ? codes : codes.filter((code) => code !== 'fe0f')).join('-');
}

/**
 * Un emoji dibujado con Twemoji (public/emoji), igual en todos los sistemas.
 * Si no hay imagen (un emblema antiguo escrito a mano), se queda el texto.
 */
export function Emoji({ emoji, className = '' }: { emoji: string; className?: string }) {
  const [attempt, setAttempt] = useState(0);
  const [key, setKey] = useState(emoji);
  if (key !== emoji) {
    setKey(emoji);
    setAttempt(0);
  }

  if (attempt > 1 || !emoji) {
    return <span className={`inline-block text-center leading-none ${className}`}>{emoji}</span>;
  }
  // Segundo intento sin ningún FE0F; si el nombre es el mismo, al texto.
  const fail = () => setAttempt(attempt === 0 && emojiFile(emoji, true) !== emojiFile(emoji) ? 1 : 2);

  return (
    <img
      src={`/emoji/${emojiFile(emoji, attempt === 1)}.svg`}
      alt={emoji}
      draggable={false}
      loading="lazy"
      className={`inline-block select-none ${className}`}
      onError={fail}
      // Si el fallo ya estaba en la caché, el evento puede llegar antes que React.
      ref={(img) => {
        if (img?.complete && img.naturalWidth === 0) fail();
      }}
    />
  );
}
